export default __webpack_public_path__ + "static/media/CSS.66b5ce7b.png";